import CMSection from '@src/components/Atoms/CMSection';
import FourCard from '@src/components/Molecules/Sponser/FourCard';
import FourText from '@src/components/Molecules/Sponser/FourText';
import { devices } from '@src/styles/theme';
import styled from 'styled-components';

const Four = () => {
  return (
    <CMSection background="linear-gradient(180deg, #FFEDE8 0%, rgba(255, 237, 232, 0.48) 37.13%, rgba(255, 237, 232, 0.00) 100%, rgba(255, 237, 232, 0.00) 100%);">
      <Wrap>
        <TextWrap>
          <FourText />
        </TextWrap>
        <FourCard />
      </Wrap>
    </CMSection>
  );
};

const Wrap = styled.div`
  padding: 110px 0;

  @media ${devices.tablet} {
    padding: 50px 0px;
  }
`;

const TextWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  @media ${devices.tablet} {
    padding: 0 24px;
  }
`;

export default Four;
